import {
  Avatar,
  AvatarGroup,
  Flex,
  Icon,
  Image,
  Progress,
  Td,
  Text,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

function DashboardTableRow(props) {
  const { logo, name, members, budget, progression } = props;
  const textColor = useColorModeValue("gray.700", "white");
  
  // Check if logo is a string (image path) or component (icon)
  const isImagePath = typeof logo === 'string';
  
  return (
    <Tr>
      <Td minWidth={{ sm: "250px" }} pl="0px">
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          {isImagePath ? (
            <Image src={logo} h={"24px"} w={"24px"}  alt={name} />
          ) : (
            <Icon as={logo} h={"24px"} w={"24px"} pe="5px" />
          )}
          <Text
          ps={"10px"}
            fontSize="md"
            color={textColor}
            fontWeight="bold"
            minWidth="100%"
          >
            {name}
          </Text>
        </Flex>
      </Td>

      <Td>
        <AvatarGroup size="sm">
          {Array.isArray(members) ? members.map((member) => {
            return (
              <Avatar
                name="Ryan Florence"
                key={member}
                src={member}
                _hover={{ zIndex: "3", cursor: "pointer" }}
              />
            );
          }) : (
            <Text fontSize="md"
            color={textColor}
            fontWeight="bold">
              {members}
            </Text>
          )}
        </AvatarGroup>
      </Td>
      <Td>
        <Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
          {budget}
        </Text>
      </Td>
      <Td>
        <Flex direction="column">
          <Text
            fontSize="md"
            color="#FF8D28"
            fontWeight="bold"
            pb=".2rem"
          >{`${progression}%`}</Text>
          <Progress
            colorScheme={progression <= 15 ? "red" :  "brand" }
            size="xs"
            value={progression}
            borderRadius="15px"
          />
        </Flex>
      </Td>
    </Tr>
  );
}

export default DashboardTableRow;
